import kr from 'Kr/kr';
import Swiper, {Navigation, Autoplay} from 'swiper';
Swiper.use([Autoplay, Navigation]);

export default class OpinionSlider extends kr.Component {
    init() {

        this.els = {
            slider: this.$element.querySelector('.js_slider'),
            nav_prev: this.$element.querySelector('.slider__nav--prev'),
            nav_next: this.$element.querySelector('.slider__nav--next'),
        };

        this.slider = new Swiper(this.els.slider, {
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 7000,
            },
            navigation: {
                nextEl: this.els.nav_next,
                prevEl: this.els.nav_prev,
            }
        });   

        this._event();
    }

    _event() {
        this.on('mouseenter', (event, current) => {
            this.slider.autoplay.stop();
        });
        this.on('mouseleave', (event, current) => {
            this.slider.autoplay.start();
        });
    }
}

kr.registerComponent('.js-opinion', {
    component: OpinionSlider
});